import React from 'react';
import { motion } from 'framer-motion';
import { Play, Gift } from 'lucide-react';
import { Button } from '../ui/button';
import { howItWorksSteps } from '../../mock/mockData';
import { HOW_ICON_MAP, CARD_RISE } from './data';

export const HowItWorks = ({ onOpenDemo }) => (
  <section id="how" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto max-w-2xl text-center">
      <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary">How it works</p>
      <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
        From your story to shared joy
      </h2>
      <p className="mt-4 text-base text-muted-foreground">You create the experience. They unwrap the story. You both feel the moment.</p>
    </div>
    <div className="mt-16 grid gap-6 md:grid-cols-3">
      {howItWorksSteps.map((step, i) => {
        const Icon = HOW_ICON_MAP[step.icon] || Gift;
        return (
          <motion.div
            key={step.id}
            {...CARD_RISE}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="group relative overflow-hidden rounded-2xl border border-border bg-card p-8 shadow-sm transition-shadow hover:shadow-xl"
            data-testid={`how-step-${step.id}`}
          >
            <div className="flex items-start justify-between">
              <span className="font-display text-7xl font-bold leading-none text-foreground/[0.06]">0{step.id}</span>
              <span className={`rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wider ${step.phase === 'You create' ? 'bg-primary/10 text-primary' : step.phase === 'You both feel it' ? 'bg-foreground text-background' : 'bg-accent/25 text-foreground'}`}>
                {step.phase}
              </span>
            </div>
            <div className="mt-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary transition-transform group-hover:scale-110">
              <Icon className="h-6 w-6" />
            </div>
            <h3 className="mt-5 font-display text-xl font-bold tracking-tight">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.description}</p>
          </motion.div>
        );
      })}
    </div>
    <div className="mt-12 text-center">
      <Button onClick={onOpenDemo} variant="outline" className="rounded-full border-foreground/15 px-6 font-semibold" data-testid="how-see-demo">
        Watch the full journey <Play className="ml-2 h-4 w-4 fill-current" />
      </Button>
    </div>
  </section>
);
